import { pgTable, text, uniqueIndex } from 'drizzle-orm/pg-core';
import { sql } from 'drizzle-orm';
import { createInsertSchema, createSelectSchema } from 'drizzle-zod';
import type { z } from 'zod';
import { generateId, recognizableId, timestamps } from './shared';

export const organizationTable = pgTable(
  'organizations',
  {
    id: recognizableId('id', { mode: 'text' })
      .primaryKey()
      .$defaultFn(() => generateId('fo')),
    name: text().notNull(),
    domain: text(),
    createdBy: text('created_by'),
    // ownerId FK constraint defined in migration to avoid circular import with user.ts
    ownerId: text('owner_id'),
    ...timestamps,
  },
  (table) => [
    uniqueIndex('idx_organization_name_unique').on(table.name),
    uniqueIndex('idx_organization_domain_unique')
      .on(table.domain)
      .where(sql`${table.domain} IS NOT NULL`),
    uniqueIndex('idx_organization_owner_id')
      .on(table.ownerId)
      .where(sql`${table.ownerId} IS NOT NULL`),
  ],
);

export const organizationSchema = createSelectSchema(organizationTable);
export const organizationInsertSchema = createInsertSchema(organizationTable);
export const organizationUpdateSchema = createInsertSchema(organizationTable).partial();
export type OrganizationSelect = z.infer<typeof organizationSchema>;
export type OrganizationInsert = z.infer<typeof organizationInsertSchema>;
export type OrganizationUpdate = z.infer<typeof organizationUpdateSchema>;
